const getSocialMediaLinks = (socialMedia)=>{
    const getIconName = (title)=>{
        if (title === 'Twitter') {
            return 'SocialX';
        }
        return `Social${title}`;
    };
    return socialMedia.map((link)=>{
        const title = link?.title === 'LinkedIn' ? 'Linkedin' : link?.title;
        return {
            href: link?.path,
            icon: getIconName(title),
            label: title || ''
        };
    });
};

export { getSocialMediaLinks };
